import { Link } from 'react-router-dom';
import { useSEO } from '../utils/seo';

export default function NotFound() {
  useSEO({
    title: 'ページが見つかりません｜株式会社BanSow',
    description: 'お探しのページは見つかりません。株式会社BanSowのホームページまたは相談事例一覧からお探しください。',
    noindex: true,
  });
  
  return (
    <main className="min-h-screen flex items-center justify-center bg-beige px-6 py-16 text-center">
      <div className="max-w-xl">
        <p className="text-7xl font-bold text-primary/20" aria-hidden="true">404</p>
        <h1 className="mt-6 text-2xl font-bold text-primary">ページが見つかりません</h1>
        <p className="mt-6 leading-relaxed text-gray-600">
          ページが移動したか、URLが異なっている可能性があります。
          以下のリンクからお探しください。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/" className="rounded-lg bg-primary px-6 py-3 text-white">ホームへ戻る</Link>
          <Link to="/cases" className="rounded-lg border border-primary px-6 py-3 text-primary">相談事例を見る</Link>
        </div>
      </div>
    </main>
  );
}
